import { BackgroundVideo } from '../components/BackgroundVideo';

const links = [
  {
    label: 'research',
    href: '#modes',
    motion: '82db2744-e3ea-1e7a-bb2e-611205f0aa0a',
    divider: '18093904-4fbe-85dc-11fa-b1c258684b1b',
  },
  {
    label: 'engineering',
    href: '#quality',
    motion: 'ecea4282-6b32-407f-fcd7-43296474475c',
    divider: '042f6f80-5bde-b3a2-020c-88124b19732b',
  },
  {
    label: 'prototyping',
    href: '#manufacturing',
    motion: 'ecbf326e-f215-e50e-e77a-e078f05b82ed',
    divider: 'f4a37d80-169d-3c9d-adaf-40b8e5b656f4',
  },
  {
    label: 'contact',
    href: '#contact',
    motion: '22600cfc-594e-61c4-807f-3c0190731d3c',
    divider: '05f536d6-595f-31ed-c185-2f7ab2b76fdd',
  },
];

export function Hero() {
  return (
    <section data-motion-id="e12b7f09-3add-a0b4-700e-c9a343bf9240" className="section_hero">
      <div className="container-full">
        <div className="content_hero">
          <div className="content_hero-top">
            <div
              data-motion-id="6098505e-657d-77dd-1be5-0d17a686bf3d"
              className="divider is-light"
            />
            <div className="hero_grid">
              <div
                data-motion-id="c3c2a070-cf83-9c72-2bb7-1f1678c8af2a"
                className="hero_logo-wrapper"
              >
                <img
                  src="/assets/images/Arcnova_Logo_Light.svg"
                  alt="Arcnova Logo"
                  className="hero_logo"
                />
              </div>
              <div>
                <h1 data-word-reveal="true" className="text-color-primary25">
                  RESEARCH&nbsp;INTO
                  <br />
                  DRONE&nbsp;AUTONOMY
                </h1>
              </div>
            </div>
          </div>
          <div
            id="w-node-_22826edb-292d-3e09-1f0c-07d1ae9db3f9-d6538631"
            className="content_hero-bottom"
          >
            <div className="hero_grid">
              <img src="/assets/images/CH_Flag.svg" alt="Swiss Flag" />
              <div className="hero_content-part">
                <p data-word-reveal="true" className="hero_paragraph">
                  Arcnova 2026 presents Ylabs LLC’s research into autonomous drone modes. The
                  research examines how sensing, onboard software, aircraft design and human
                  oversight shape autonomous behaviour.
                </p>
                <div
                  data-motion-id="a8b7271e-b699-d5a9-905a-e7bfdd9312a0"
                  className="hero_menu-wrapper"
                >
                  {links.map((link, i) => (
                    <a
                      key={link.href}
                      data-motion-id={link.motion}
                      href={link.href}
                      className="hero_element-wrapper w-inline-block"
                    >
                      <div className="hero_element-hover" aria-hidden="true">
                        <div className="hero_text-hover">{link.label}</div>
                        <div className="hero_icon-hover">
                          <div>{i + 1}</div>
                        </div>
                      </div>
                      <div className="hero_element">
                        <div className="hero_text">{link.label}</div>
                        <div className="menu_icon is-light">
                          <div className="menu_icon-text">{i + 1}</div>
                        </div>
                      </div>
                      <div data-motion-id={link.divider} className="menu-divider" />
                      {i === 3 && (
                        <div
                          data-motion-id="e7f65622-7e4b-6d11-5e4e-362944ac377c"
                          className="menu-divider is-bottom"
                        />
                      )}
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BackgroundVideo name="arcnova-hero-video" className="hero_video" tone="green" eager />
    </section>
  );
}
